import { z } from 'zod';
import {
  type CloudResourceIdSiteSeparationRequestRule,
  type CloudResourceIdSiteSeparationRule,
  cloudResourceIdSiteSeparationRequestRuleSchemaZ,
  cloudResourceIdSiteSeparationRuleSchemaZ,
} from './cloudResourceIdSiteSeparationRule';
import {
  type CloudResourceTagSiteSeparationRequestRule,
  type CloudResourceTagSiteSeparationRule,
  cloudResourceTagSiteSeparationRequestRuleSchemaZ,
  cloudResourceTagSiteSeparationRuleSchemaZ,
} from './cloudResourceTagSiteSeparationRule';
import {
  type RegexSiteSeparationRequestRule,
  type RegexSiteSeparationRule,
  type RegexSiteSeparationType,
  regexSiteSeparationRequestRuleSchemaZ,
  regexSiteSeparationRuleSchemaZ,
  regexSiteSeparationTypes,
} from './regexSiteSeparationRule';
import {
  type RoutingSwitchingSiteSeparationRequestRule,
  type RoutingSwitchingSiteSeparationRule,
  routingSwitchingSiteSeparationRequestRuleSchemaZ,
  routingSwitchingSiteSeparationRuleSchemaZ,
} from './routingSwitchingSiteSeparationRule';
import {
  type SlugSiteSeparationRequestRule,
  type SlugSiteSeparationRule,
  slugSiteSeparationRequestRuleSchemaZ,
  slugSiteSeparationRuleSchemaZ,
} from './slugSiteSeparationRule';

export type SiteSeparationRule =
  | RegexSiteSeparationRule
  | RoutingSwitchingSiteSeparationRule
  | SlugSiteSeparationRule
  | CloudResourceIdSiteSeparationRule
  | CloudResourceTagSiteSeparationRule;

export const isRegexSiteSeparationRule = (
  rule: SiteSeparationRule,
): rule is RegexSiteSeparationRule =>
  regexSiteSeparationTypes.includes(rule.type as RegexSiteSeparationType);

export const isRoutingSwitchingSiteSeparationRule = (
  rule: SiteSeparationRule,
): rule is RoutingSwitchingSiteSeparationRule =>
  rule.type === 'routingSwitching';

export const isCloudResourceIdSiteSeparationRule = (
  rule: SiteSeparationRule,
): rule is CloudResourceIdSiteSeparationRule =>
  rule.type === 'regexCloudResourceId';

export const isCloudResourceTagSiteSeparationRule = (
  rule: SiteSeparationRule,
): rule is CloudResourceTagSiteSeparationRule =>
  rule.type === 'cloudResourceTag';

export const isHostnameSiteSeparationRule = (
  rule: SiteSeparationRule,
): rule is RegexSiteSeparationRule => rule.type === 'regexHostname';

export const isSlugSiteSeparationRule = (
  rule: SiteSeparationRule,
): rule is SlugSiteSeparationRule => rule.type === 'slug';

export type SiteSeparationRequestRule =
  | RegexSiteSeparationRequestRule
  | RoutingSwitchingSiteSeparationRequestRule
  | SlugSiteSeparationRequestRule
  | CloudResourceIdSiteSeparationRequestRule
  | CloudResourceTagSiteSeparationRequestRule;

export const siteSeparationRequestRuleSchemaZ = z
  .union([
    regexSiteSeparationRequestRuleSchemaZ,
    routingSwitchingSiteSeparationRequestRuleSchemaZ,
    slugSiteSeparationRequestRuleSchemaZ,
    cloudResourceIdSiteSeparationRequestRuleSchemaZ,
    cloudResourceTagSiteSeparationRequestRuleSchemaZ,
  ])
  .optional();

export const siteSeparationRuleSchemaZ = z
  .union([
    regexSiteSeparationRuleSchemaZ,
    routingSwitchingSiteSeparationRuleSchemaZ,
    slugSiteSeparationRuleSchemaZ,
    cloudResourceIdSiteSeparationRuleSchemaZ,
    cloudResourceTagSiteSeparationRuleSchemaZ,
  ])
  .optional();
